import React, { useState } from 'react';
import styles from './blogs.module.css';
import blogData from "./blogs.json";
import { Link } from "react-router-dom";


const Blog = () => {
  return (
    <>
      <div className={styles.blogSection}>
        <header className={styles.blogHeader}>
          <h2>Our Recent <span className={styles.highlight}>Blogs</span></h2>
          <div className={styles.headerBar}></div>
        </header>
        
        <div className={styles.blogGrid}>
          {blogData.map((post) => (
            <a
              href={post.link}
              key={post.id}
              className={styles.blogCard}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div 
                className={styles.cardBg}
                style={{ backgroundImage: `url(${post.image})` }}
              ></div>
          
              <div className={styles.cardOverlay}></div>

              <div className={styles.cardContent}>
                <span className={styles.cardCategory}>{post.category}</span>
                <h3 className={styles.cardTitle}>{post.title}</h3>
                
                <div className={styles.cardDescContainer}>
                  <p className={styles.shortDesc}>{post.shortDesc}</p>
                  <p className={styles.longDesc}>{post.longDesc}</p>
                </div>
                
                <div className={styles.readMore}>
                  Read Article <span className={styles.arrow}>→</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default Blog;